import {
  Block,
  Button,
  HeadingLarge,
  LabelMedium,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useLocalStorage } from "usehooks-ts"

import ilustrationSrc from "#/assets/welcome-to-mainnet-cover.png"
import {
  IS_MEZO_MAINNET,
  LOCAL_STORAGE_MAINNET_WELCOME_MODAL_VISIBLE,
} from "#/shared/constants"

import BaseModal from "./BaseModal"

function MainnetWelcomeModal() {
  const [shouldRenderModal, setShouldRenderModal] = useLocalStorage(
    LOCAL_STORAGE_MAINNET_WELCOME_MODAL_VISIBLE,
    IS_MEZO_MAINNET,
  )

  const [, theme] = useStyletron()

  return (
    <BaseModal
      isOpen={shouldRenderModal}
      closeable={false}
      overrides={{
        Dialog: {
          style: {
            height: "100%",
          },
        },
      }}
    >
      <Block padding={theme.sizing.scale800}>
        <Block
          display="grid"
          placeItems="center"
          width="100%"
          height="206px"
          marginBottom={theme.sizing.scale700}
          backgroundColor="#0B74D717"
          overrides={{
            Block: { style: { borderRadius: theme.borders.radius500 } },
          }}
        >
          <Block
            as="img"
            src={ilustrationSrc}
            width="100%"
            height="206px"
            overrides={{ Block: { style: { objectFit: "contain" } } }}
          />
        </Block>
        <LabelMedium
          marginBottom={theme.sizing.scale300}
          color={theme.colors.contentSecondary}
        >
          Welcome to Mezo Mainnet!
        </LabelMedium>
        <HeadingLarge marginBottom={theme.sizing.scale300}>
          <Block as="span" display="inline-block" color={theme.colors.accent}>
            Mezo
          </Block>{" "}
          is now on Mainnet.
        </HeadingLarge>
        <ParagraphLarge marginBottom={theme.sizing.scale600}>
          You can now borrow and spend your MUSD.
        </ParagraphLarge>
        <Button width="100%" onClick={() => setShouldRenderModal(false)}>
          Let&apos;s go
        </Button>
      </Block>
    </BaseModal>
  )
}

export default MainnetWelcomeModal
